module.exports = __webpack_public_path__ + "static/media/general-de-seguros-bumper_selected.288fd8fe.svg";